module.exports = __webpack_public_path__ + "img/3_32.39c964f0.png";